export default function UICTA() {
  return (
    <section className="py-16 md:py-20 bg-[#1B2A4A] relative overflow-hidden">
      <div className="absolute inset-0 opacity-5" style={{ backgroundImage: "radial-gradient(circle at 20% 50%, #fff 1px, transparent 1px), radial-gradient(circle at 80% 20%, #fff 1px, transparent 1px)", backgroundSize: "60px 60px, 80px 80px" }}></div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 md:px-8 text-center">
        <div className="inline-flex items-center gap-2 bg-white/10 text-white/80 text-xs font-semibold px-4 py-2 rounded-full mb-6">
          <i className="ri-map-pin-line text-[#7FBF3F]"></i>Sarjapur Road, Bengaluru
        </div>
        <h2 className="text-3xl md:text-5xl font-bold text-white mb-5 leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
          Looking for the Perfect Plot in Bengaluru?
        </h2>
        <p className="text-white/70 text-lg mb-10 max-w-2xl mx-auto leading-relaxed">
          Contact URBAN INFRA for project details, pricing, and site visit. Our team is ready to help you find the right villa plot or residential layout on Sarjapur Road.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-10">
          <a href="tel:+919945124133" className="inline-flex items-center justify-center gap-2 bg-white hover:bg-gray-100 text-[#1B2A4A] font-bold px-8 py-4 rounded-lg transition-colors cursor-pointer whitespace-nowrap text-base">
            <i className="ri-phone-fill"></i>Call Now
          </a>
          <a href="https://wa.me/919945124133" target="_blank" rel="nofollow noreferrer" className="inline-flex items-center justify-center gap-2 bg-[#7FBF3F] hover:bg-[#6aaa32] text-white font-bold px-8 py-4 rounded-lg transition-colors cursor-pointer whitespace-nowrap text-base">
            <i className="ri-whatsapp-line"></i>WhatsApp Now
          </a>
          <a href="/contact" className="inline-flex items-center justify-center gap-2 bg-transparent border-2 border-white/40 hover:bg-white/10 text-white font-bold px-8 py-4 rounded-lg transition-colors cursor-pointer whitespace-nowrap text-base">
            <i className="ri-calendar-check-line"></i>Book Now
          </a>
        </div>

        <div className="flex flex-col sm:flex-row gap-6 justify-center text-white/60 text-sm">
          <a href="tel:+919945124133" className="flex items-center gap-2 hover:text-white transition-colors cursor-pointer">
            <i className="ri-phone-line text-[#7FBF3F]"></i>+91 9945124133
          </a>
          <a href="mailto:sales@urbaninfraproject.in" className="flex items-center gap-2 hover:text-white transition-colors cursor-pointer">
            <i className="ri-mail-line text-[#7FBF3F]"></i>sales@urbaninfraproject.in
          </a>
          <span className="flex items-center gap-2">
            <i className="ri-global-line text-[#7FBF3F]"></i>www.urbaninfraprojects.in
          </span>
        </div>
      </div>
    </section>
  );
}
